module.exports = __webpack_public_path__ + "assets/azure_authenticated_icon.c5025422.svg";